"use client";
import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { useState as b } from "react";
import o from "../Collapse/index.js";
import w from "../Icon/index.js";
import y from "../Image/index.js";
const V = ({ title: c, source: l, poster: t, caption: r, transcript: i, embedClass: m, className: n, ...h }) => {
  const [a, f] = b(!!t), d = ["youtube", "vimeo", "wistia"].some((p) => l == null ? void 0 : l.includes(p));
  if (!l)
    return null;
  const u = () => f(!1);
  return /* @__PURE__ */ s(
    "div",
    {
      className: `sash-Video ${n || ""}`,
      ...h,
      children: [
        /* @__PURE__ */ s("div", { className: `sash-VideoWrapper relative aspect-video ${n || ""}`, children: [
          a && t && /* @__PURE__ */ s(
            "button",
            {
              onClick: u,
              className: "sash-VideoPoster absolute left-0 top-0 block h-full w-full",
              children: [
                /* @__PURE__ */ e(
                  w,
                  {
                    name: "play_arrow",
                    fill: 1,
                    size: 56,
                    className: "absolute left-1/2 top-1/2 flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-4 border-white bg-primary shadow-md"
                  }
                ),
                /* @__PURE__ */ e(
                  y,
                  {
                    src: t,
                    className: "h-full w-full"
                  }
                )
              ]
            }
          ),
          !d && /* @__PURE__ */ e(
            "video",
            {
              controls: !0,
              className: `sash-VideoInternal absolute left-0 top-0 h-full w-full ${a ? "hidden" : "block"}`,
              children: /* @__PURE__ */ e(
                "source",
                {
                  src: l,
                  type: "video/mp4"
                }
              )
            }
          ),
          d && /* @__PURE__ */ e(
            "iframe",
            {
              title: c,
              src: l,
              loading: "lazy",
              className: `sash-VideoEmbed absolute left-0 top-0 h-full w-full border-0 ${a ? "hidden" : "block"} ${m || ""}`,
              allowFullScreen: !0
            }
          )
        ] }),
        r && /* @__PURE__ */ e("p", { className: "sash-VideoCaption py-2 text-sm text-gray-60", children: r }),
        i && /* @__PURE__ */ s(
          o,
          {
            className: "sash-VideoTranscript",
            title: "Transcript",
            children: [
              /* @__PURE__ */ e(o.Trigger, { children: "Transcript" }),
              /* @__PURE__ */ e(o.Content, { children: /* @__PURE__ */ e("div", { dangerouslySetInnerHTML: { __html: i } }) })
            ]
          }
        )
      ]
    }
  );
}, k = V;
export {
  k as default
};
